import { createContext } from "react";

const PatientContext = createContext();

export default PatientContext;